import { applyTheme, THEME_STORAGE_KEY, type Theme } from "@/lib/theme";

/**
 * Both icons are always rendered and CSS shows one. This is deliberate: the site is
 * prerendered by vite-react-ssg, so any markup that differs by theme would differ
 * between the prerendered HTML and the first client render — the same class of
 * hydration mismatch that once mounted a second copy of the whole app (Shot.tsx).
 * Reading the theme in an effect to pick an icon would reintroduce exactly that.
 */
export function ThemeToggle() {
  function toggle() {
    const next: Theme = document.documentElement.classList.contains("light") ? "dark" : "light";
    applyTheme(next);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, next);
    } catch {
      /* private mode — the choice just won't survive the session */
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Switch theme"
      className="flex h-9 w-9 items-center justify-center rounded text-bone-dim transition-colors hover:bg-panel/70 hover:text-bone"
    >
      {/* Shown in dark: offers the switch to light. */}
      <svg className="theme-icon-sun h-[1.125rem] w-[1.125rem]" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      </svg>
      {/* Shown in light: offers the switch to dark. */}
      <svg className="theme-icon-moon h-[1.125rem] w-[1.125rem]" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
      </svg>
    </button>
  );
}
